// fetchData.ts
// axios请求封装，参考 test.js 风格，自动携带 pinia userObj
import axios from "axios";
import pinia from "@/pinia/pinia";
import { useMainStore } from "@/pinia/main";
import envObj from "./env";
let Appkey = "EIBnBlYuvK";
if (envObj?.env !== "prod") {
  Appkey = "ZwkfaXXXfI";
}
const store = useMainStore(pinia);
export interface FetchOptions {
  api: string;
  domain?: "userlogin" | "default" | string;
  data?: any;
  params?: any;
  headers?: Record<string, any>;
  success?: (data: any) => void;
  fail?: (err: any) => void;
}

const handleDomain = (
  domain: FetchOptions["domain"],
  headers: Record<string, any>,
  api: string,
) => {
  delete headers["nickname"];
  if (/^https?:\/\//i.test(api)) {
    return { _headers: headers, _api: api };
  }
  switch (domain) {
    case "userlogin": {
      api = `${envObj?.mktcsc ?? ""}${api}`;
      break;
    }
    case "topic": {
      api = `${envObj?.actTopicBaseUrl ?? ""}${api}`;
      break;
    }
     case "follow": {
      axios.defaults.withCredentials = false;
      api = `${envObj?.followBaseUrl ?? ""}${api}`;
      break;
    }
    default: {
      api = `${envObj?.actBaseUrl ?? ""}${api}`;
    }
  }
  return { _headers: headers, _api: api };
};

const fetchData = {
  /**
   * GET请求
   * @param options 请求参数
   */
  async doGet({
    api,
    domain,
    data = {},
    headers = {},
    success,
    fail,
  }: FetchOptions) {
    axios.defaults.withCredentials = false;
    let raw_headers = { ...store.userObj, ...headers };
    let { _headers, _api } = handleDomain(domain, raw_headers, api);
    // delete _headers["uid"];
    try {
      const res = await axios.get(_api, {
        params: data,
        headers: { ..._headers, Appkey },
      });
      if (typeof success === "function") success(res.data);
      return res.data;
    } catch (err) {
      if (typeof fail === "function") fail(err);
      throw err;
    }
  },
  /**
   * POST请求
   * @param options 请求参数
   */
  async doPost({
    api,
    domain,
    data = {},
    params = {},
    headers = {},
    success,
    fail,
  }: FetchOptions) {
    axios.defaults.withCredentials = false;
    let raw_headers = { ...store.userObj, ...headers };
    let { _headers, _api } = handleDomain(domain, raw_headers, api);
    try {
      const res = await axios.post(_api, data, {
        params,
        headers: { ..._headers, Appkey },
      });
      if (typeof success === "function") success(res.data);
      return res.data;
    } catch (err) {
      if (typeof fail === "function") fail(err);
      throw err;
    }
  },
};
export default fetchData;
